"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentUserProfilePicture = void 0;
exports.selectProfilePicture = selectProfilePicture;
exports.selectProfilePicturesMap = selectProfilePicturesMap;
var immutable_1 = require("immutable");
var toolkit_1 = require("@reduxjs/toolkit");
var config_1 = require("config");
var config = (0, config_1.get)();
var communityProfileEnabled = !!(config && config.features
    && config.features.communityProfile);
var EMPTY_PICTURE = { url: '', small: '', card: '' };
var EMPTY_MAP = (0, immutable_1.Map)();
// Cache .toJS() conversions keyed on the Immutable object itself.
// WeakMap allows GC to reclaim entries when the Immutable object is no longer referenced,
// preventing unbounded memory growth as users are viewed.
var _toJsCache = new WeakMap();
/**
 * Select a profile picture for a given uid from the GraphQL lookup table.
 *
 * Feature-flag gated:
 *   ON  → returns { url, small, card } (empty strings if not yet loaded)
 *   OFF → returns null (callers use their existing REST paths)
 */
function selectProfilePicture(state, uid) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return EMPTY_PICTURE;
    var key = String(uid);
    var gql = state.communityProfile.getIn(['profilePictures', 'data', key]);
    if (gql && gql.size > 0) {
        var cached = _toJsCache.get(gql);
        if (cached) {
            return cached;
        }
        var result = gql.toJS();
        _toJsCache.set(gql, result);
        return result;
    }
    return EMPTY_PICTURE;
}
var selectAuthUid = function (state) { return state.auth.get('uid'); };
var selectProfilePicturesData = function (state) { return (state.communityProfile.getIn(['profilePictures', 'data'])); };
/**
 * Memoized selector for the current user's profile picture.
 * Uses createSelector so the derived .toJS() object is referentially stable
 * across renders when the underlying Immutable data hasn't changed.
 */
exports.selectCurrentUserProfilePicture = (0, toolkit_1.createSelector)([selectAuthUid, selectProfilePicturesData], function (uid, data) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return EMPTY_PICTURE;
    var key = String(uid);
    var gql = data ? data.get(key) : undefined;
    if (gql && gql.size > 0) {
        return gql.toJS();
    }
    return EMPTY_PICTURE;
});
/**
 * Select the entire profilePictures lookup Map.
 *
 * Feature-flag gated:
 *   ON  → returns Immutable Map keyed by uid string
 *   OFF → returns empty Map (callers fall back to REST paths)
 */
function selectProfilePicturesMap(state) {
    if (!communityProfileEnabled)
        return EMPTY_MAP;
    var data = selectProfilePicturesData(state);
    return data || EMPTY_MAP;
}
